export const PaymentDirection = {
  INCOMING: "INCOMING",
  OUTGOING: "OUTGOING",
} as const;
export type PaymentDirection =
  (typeof PaymentDirection)[keyof typeof PaymentDirection];

export const PaymentPartnerType = {
  CUSTOMER: "CUSTOMER",
  SUPPLIER: "SUPPLIER",
  OTHER: "OTHER",
} as const;
export type PaymentPartnerType =
  (typeof PaymentPartnerType)[keyof typeof PaymentPartnerType];

export const PaymentState = {
  DRAFT: "DRAFT",
  POSTED: "POSTED",
  IN_PROCESS: "IN_PROCESS",
  PAID: "PAID",
  CANCELLED: "CANCELLED",
  REJECTED: "REJECTED",
  UNKNOWN: "UNKNOWN",
} as const;
export type PaymentState = (typeof PaymentState)[keyof typeof PaymentState];

export const VendorBillPaymentState = {
  NOT_PAID: "NOT_PAID",
  IN_PAYMENT: "IN_PAYMENT",
  PARTIAL: "PARTIAL",
  PAID: "PAID",
  REVERSED: "REVERSED",
  INVOICING_LEGACY: "INVOICING_LEGACY",
  UNKNOWN: "UNKNOWN",
} as const;
export type VendorBillPaymentState =
  (typeof VendorBillPaymentState)[keyof typeof VendorBillPaymentState];

export interface PaymentDto {
  id: number;
  direction: PaymentDirection;
  partnerType: PaymentPartnerType;
  partnerId: number | null;
  partnerName: string | null;
  amount: number;
  currency: string | null;
  state: PaymentState;
  journalName: string | null;
  reference: string | null;
  memo: string | null;
  date: string | null;
  reconciledInvoiceIds: number[];
  reconciledBills: Array<{ id: number; name: string; previewUrl: string | null }>;
  originRef: string | null;
  saleOrderRef: string | null;
}

export interface VendorBillDto {
  id: number;
  supplierId: number | null;
  supplierName: string | null;
  reference: string | null;
  invoiceDate: string | null;
  dueDate: string | null;
  amountTotal: number;
  amountResidual: number;
  currency: string | null;
  paymentState: VendorBillPaymentState;
  state: string | null;
}

export interface ListPaymentsQueryDto {
  page?: number;
  pageSize?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  direction?: PaymentDirection;
  partnerType?: PaymentPartnerType;
  partnerId?: number;
}

export interface UnpaidBillsQueryDto {
  page?: number;
  pageSize?: number;
  search?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export interface PayVendorBillDto {
  billId: number;
  amount?: number;
  paymentDate?: string;
  journalId?: number;
  memo?: string;
}
